// eslint-disable-next-line no-restricted-imports
import { SessionModel, SessionResponse } from 'types';
import genericNormalizer, { normalizeDate } from './generic';

export const normalizeSession = genericNormalizer<
  SessionResponse,
  SessionModel
>(({ from, has }) => ({
  dateLastUsed: has('dateLastUsed', normalizeDate),
  id: from('id'),
  ipAddress: from('ipAddress'),
  isCurrent: from('isCurrent'),
}));



// WEBPACK FOOTER //
// ./app/gamma/src/api/normalizers/session.ts